import { findOuById, getAllChildProducts, useOrganisationHierarchy, useProductWithHierarchy } from '@app/sdk';
import React, { useMemo } from 'react';
import { ColDef } from 'ag-grid-community';
import { LoadingWrapper } from '../components/LoadingWrapper';
import { Table } from '@app/shared';

export function AffectedProducts({ selectedOuId }: { selectedOuId: string }) {
  const { data: tenantHierarchy } = useOrganisationHierarchy();
  const { isLoading: loading, data: allProducts } = useProductWithHierarchy();

  const affectedProducts = useMemo(() => {
    if (tenantHierarchy && allProducts) {
      const selectedOu = findOuById(tenantHierarchy.organisationUnit, selectedOuId);
      const productIds = getAllChildProducts(selectedOu);
      return allProducts.filter((x) => productIds.includes(x.productId));
    }
    return [];
  }, [tenantHierarchy, allProducts, selectedOuId]);

  const columnDefs: ColDef[] = [
    { field: 'productId', headerName: 'ID' },
    { field: 'label', headerName: 'Label' },
    { field: 'parent.name', headerName: 'Parent OU' },
  ];

  return (
    <LoadingWrapper loading={loading}>
      <div style={{ height: '350px', position: 'relative' }}>
        <Table items={affectedProducts} columnDefs={columnDefs} noFilter />
        <div className={'ui label'} style={{ position: 'absolute', top: '-30px', right: '10px' }}>
          {affectedProducts.length} Affected Products
        </div>
      </div>
    </LoadingWrapper>
  );
}
